var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"InputText"},[(_vm.label)?_c('div',{staticClass:"InputText-Label"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('input',{staticClass:"InputText-Input",class:{ "fill-column": !_vm.label },attrs:{"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":_vm.handleChange}})])
}
var staticRenderFns = []

export { render, staticRenderFns }